module.exports = __webpack_public_path__ + "static/media/bg6b.313199cc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/dummy-images/bg6b.jpeg
// module id = ./src/CSS/assets-minified/dummy-images/bg6b.jpeg
// module chunks = 0